/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'prompt-icon': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" d="M3.15 7.426a.473.473 0 1 0 .67-.67l-.67.67ZM1.773 4.712a.473.473 0 1 0-.669.67l.669-.67Zm-.658-.01a.473.473 0 0 0 .647.689l-.647-.69ZM3.809 3.47a.473.473 0 1 0-.648-.69l.648.69ZM1.437 4.573a.473.473 0 0 0 0 .947v-.947Zm5.14.474.002-.474h-.002v.474Zm1.27-.522.334.335-.334-.335ZM8.85 3.259a.473.473 0 0 0-.946-.002l.946.002ZM3.82 6.756 1.772 4.712l-.669.67 2.048 2.044.668-.67ZM1.761 5.391 3.81 3.47l-.648-.69-2.047 1.921.647.69Zm-.323.129h5.14v-.947h-5.14v.947Zm5.138 0a2.267 2.267 0 0 0 1.605-.66l-.667-.67a1.32 1.32 0 0 1-.935.383l-.003.947Zm1.605-.66c.426-.424.667-1 .668-1.6l-.946-.003a1.32 1.32 0 0 1-.39.932l.668.671Z" _fill="#fff"/>'
  }
})
